import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserGroup } from '@shared/interfaces';
import { UserGroupService } from '@core/services/user-group.service';

@Component({
    selector: 'app-menu-group[closePopover]',
    templateUrl: './menu-group.component.html',
    styleUrls: ['./menu-group.component.scss'],
})
export class MenuGroupComponent implements OnInit {
    @Input() displayBackButton: boolean = false;
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();

    userGroups: UserGroup[] = [];
    selectedGroupId = '1';

    constructor(private userGroupService: UserGroupService) {
        this.userGroupService.currentGroup$.subscribe(userGroup => {
            this.selectedGroupId = userGroup.id;
        });
    }

    ngOnInit(): void {
        this.initializeUserGroups();
        this.userGroupService.switchGroup(this.userGroups[0]);
    }

    initializeUserGroups(): void {
        this.userGroups = [
            {
                id: '1',
                name: 'DC Lab 1',
            },
            {
                id: '2',
                name: 'COMA Lab 1',
            },
            {
                id: '3',
                name: 'AG Lab 2',
            },
            {
                id: '4',
                name: 'MB Lab 3',
            },
            {
                id: '5',
                name: 'GM Lab 4',
            },
        ];
    }

    selectGroup(group: UserGroup) {
        this.userGroupService.switchGroup(group);
    }

    close(): void {
        this.closePopover.emit();
    }
}
